import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

export default function CustomFieldFormMarketingFields({ compField, marketing, features, options, onChange }) {
  if (!features.marketingIntegration || compField) {
    return null;
  }

  function toggleMarketing(enable) {
    if (enable) {
      const type = options.marketingTypes[0].value;
      const field = getMarketingFieldOptionsForType(options, type)[0].value;
      onChange({ marketing: { type, field } });
    } else {
      onChange({ marketing: null });
    }
  }

  function handleChange(changes) {
    onChange({ marketing: { ...marketing, ...changes } });
  }

  return <React.Fragment>
    <ManagedInput
      checked={marketing != null}
      label="Associate with marketing?"
      type="checkbox"
      onValueChange={toggleMarketing}
    />

    {marketing != null &&
      <React.Fragment>
        <ManagedFormGroup
          label="Marketing model"
          name="type"
          required
          type="select"
          value={marketing.type}
          onChange={handleChange}
        >
          <Options options={options.marketingTypes} />
        </ManagedFormGroup>

        <ManagedFormGroup
          label="Marketing field"
          name="field"
          required
          type="select"
          value={marketing.field}
          onChange={handleChange}
        >
          <Options options={getMarketingFieldOptionsForType(options, marketing.type)} />
        </ManagedFormGroup>
      </React.Fragment>
    }
  </React.Fragment>;
}

function getMarketingFieldOptionsForType(options, type) {
  return options.marketingFieldsAndTypes
    .find(option => option.type === type)
    .fields
    .map(field => ({ label: field, value: field }));
}

CustomFieldFormMarketingFields.propTypes = {
  compField: PropTypes.bool,
  features: PropTypes.shape({
    marketingIntegration: PropTypes.bool,
  }).isRequired,
  fieldsByType: PropTypes.object.isRequired,
  marketing: PropTypes.shape({
    type: PropTypes.string,
    field: PropTypes.string,
  }),
  options: PropTypes.shape({
    marketingTypes: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
